(ns frontend.ui.component.lp-portal.report.body.private-equity.fund.natural-capital.pdf-pages.toc-page
(:require
   [clojure.string :as s]
   [frontend.ui.style.theme.core :as theme]
   [frontend.utils :as fu] 
   [frontend.ui.component.lp-portal.page.pdf.view :as page]))

(defn toc-page
  [{:keys [cover-image report-data]}]
  [(page/page
    "TOC"
    {:stack [{:absolutePosition {:x 0 :y 0}
              :image cover-image
              :width 1080}
             {:stack [{:svg    (theme/svg-logo-light)
                       :fit    [120 40]
                       :margin [0 0 0 0]
                       :absolutePosition {:x 20
                                          :y 550}} 
                      {:text     (str (or (:fund-name report-data) "")
                                      " "
                                      (-> report-data
                                          :reference-date
                                          (fu/format-date-ts "." true)
                                          (or "")
                                          (s/upper-case)))
                       :absolutePosition {:x 110 :y 250}
                       :fontSize 25 
                       :color    (theme/color [:pdf :landing-page :text])}]}]})])
